module.exports = __webpack_public_path__ + "images/corners/Thales.517aeffbdd1aea925ff8ff47137a78e9.jpg";